// import { ReactComponent as Filter } from "./filter.svg";

function SvgFilter() {
  return null;
}
export default SvgFilter;
